module.exports = __webpack_public_path__ + "d4c0b303/img/verified-icon.f93bbc14.svg";